import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import Title from "../../../../../base/text/title/index.js";
import contextBabylon from "../../../../../../context/index.js";
import Highlight from "../../components/highlights/index.js";
import MapItems from "../../components/map/index.js";
import * as S from "./styled.js";
export const MapCoasts = ({ props  })=>{
    const { title , subtitle , image  } = props ?? {};
    const { Cdn , Language  } = useContext(contextBabylon);
    return /*#__PURE__*/ _jsx(S.BackgroundImage, {
        $backgroundImage: `${Cdn}${image}`,
        children: /*#__PURE__*/ _jsxs(S.MapCoastsContainer, {
            "data-testid": "MapCoasts",
            children: [
                title && /*#__PURE__*/ _jsx(Title, {
                    title: title,
                    subTitle: subtitle
                }),
                /*#__PURE__*/ _jsxs(S.Wrapper, {
                    children: [
                        /*#__PURE__*/ _jsx(Highlight, {
                            props: props
                        }),
                        /*#__PURE__*/ _jsx(MapItems, {
                            props: props,
                            language: Language
                        })
                    ]
                })
            ]
        })
    });
};
export default MapCoasts;

//# sourceMappingURL=index.js.map